import { isEmpty } from "lodash";
import * as actions from "../../actions/onm-action/poweramrTypes";
import { getItem } from "../../SecureStorage";

const userData = JSON.parse(getItem("onmUserData"));

const INITIAL_STATE = {
  login: {
    post: {
      loading: false,
      reset: false,
      loggedIn: !isEmpty(userData),
      success: {
        ok: false,
        data: {
          PLANT_Code: userData?.PLANT_Code,
          USERNAME: userData?.USERNAME,
          CITY: userData?.CITY,
          ADDRESS: userData?.ADDRESS,
          PASS_KEY: userData?.PASS_KEY,
        },
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  devices: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: {},
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  inverterLogData: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  inverterStringData: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: {},
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  plantStatus: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: {},
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  dashboardStats: {
    post: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: {},
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  alarms: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  generationGraphData: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  inverterGraphData: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: [],
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
  metricTrends: {
    post: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: {},
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
};

const powerAMRReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.POWERAMR_LOGIN_LOADING:
      return {
        ...state,
        login: {
          ...state.login,
          post: {
            ...state.login.post,
            loading: true,
            reset: false,
            success: {
              ...state.login.post.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.POWERAMR_LOGIN_SUCCESS:
      return {
        ...state,
        login: {
          ...state.login,
          post: {
            ...state.login.post,
            loading: false,
            reset: false,
            loggedIn: true,
            success: {
              ...state.login.post.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.POWERAMR_LOGIN_FAILURE:
      return {
        ...state,
        login: {
          ...state.login,
          post: {
            ...state.login.post,
            loading: false,
            reset: false,
            success: {
              ...state.login.post.success,
              ok: false,
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.POWERAMR_LOGIN_RESET:
      return {
        ...state,
        login: {
          ...state.login.post,
          post: {
            ...INITIAL_STATE.login.post,
            reset: true,
          },
        },
      };
    case actions.GET_DEVICE_LIST_LOADING:
      return {
        ...state,
        devices: {
          ...state.devices,
          get: {
            ...state.devices.get,
            loading: true,
            reset: false,
            success: {
              ...state.devices.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_DEVICE_LIST_SUCCESS:
      return {
        ...state,
        devices: {
          ...state.devices,
          get: {
            ...state.devices.get,
            loading: false,
            reset: false,
            success: {
              ...state.devices.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_DEVICE_LIST_FAILURE:
      return {
        ...state,
        devices: {
          ...state.devices,
          get: {
            ...state.devices.get,
            loading: false,
            reset: false,
            success: {
              ...state.devices.get.success,
              ok: false,
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_DEVICE_LIST_RESET:
      return {
        ...state,
        devices: {
          ...state.devices.get,
          get: {
            ...INITIAL_STATE.devices.get,
            reset: true,
          },
        },
      };
    case actions.GET_DEVICE_LIST_LOADING:
      return {
        ...state,
        devices: {
          ...state.devices,
          get: {
            ...state.devices.get,
            loading: true,
            reset: false,
            success: {
              ...state.devices.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_DEVICE_LIST_SUCCESS:
      return {
        ...state,
        devices: {
          ...state.devices,
          get: {
            ...state.devices.get,
            loading: false,
            reset: false,
            success: {
              ...state.devices.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_DEVICE_LIST_FAILURE:
      return {
        ...state,
        devices: {
          ...state.devices,
          get: {
            ...state.devices.get,
            loading: false,
            reset: false,
            success: {
              ...state.devices.get.success,
              ok: false,
              data: [],
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_DEVICE_LIST_RESET:
      return {
        ...state,
        devices: {
          ...state.devices.get,
          get: {
            ...INITIAL_STATE.devices.get,
            reset: true,
          },
        },
      };
    case actions.GET_INVERTER_LOG_DATA_LOADING:
      return {
        ...state,
        inverterLogData: {
          ...state.inverterLogData,
          get: {
            ...state.inverterLogData.get,
            loading: true,
            reset: false,
            success: {
              ...state.inverterLogData.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_INVERTER_LOG_DATA_SUCCESS:
      return {
        ...state,
        inverterLogData: {
          ...state.inverterLogData,
          get: {
            ...state.inverterLogData.get,
            loading: false,
            reset: false,
            success: {
              ...state.inverterLogData.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_INVERTER_LOG_DATA_FAILURE:
      return {
        ...state,
        inverterLogData: {
          ...state.inverterLogData,
          get: {
            ...state.inverterLogData.get,
            loading: false,
            reset: false,
            success: {
              ...state.inverterLogData.get.success,
              ok: false,
              data: [],
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_INVERTER_LOG_DATA_RESET:
      return {
        ...state,
        inverterLogData: {
          ...state.inverterLogData.get,
          get: {
            ...INITIAL_STATE.inverterLogData.get,
            reset: true,
          },
        },
      };
    case actions.GET_INVERTER_STRING_DATA_LOADING:
      return {
        ...state,
        inverterStringData: {
          ...state.inverterStringData,
          get: {
            ...state.inverterStringData.get,
            loading: true,
            reset: false,
            success: {
              ...state.inverterStringData.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_INVERTER_STRING_DATA_SUCCESS:
      return {
        ...state,
        inverterStringData: {
          ...state.inverterStringData,
          get: {
            ...state.inverterStringData.get,
            loading: false,
            reset: false,
            success: {
              ...state.inverterStringData.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_INVERTER_STRING_DATA_FAILURE:
      return {
        ...state,
        inverterStringData: {
          ...state.inverterStringData,
          get: {
            ...state.inverterStringData.get,
            loading: false,
            reset: false,
            success: {
              ...state.inverterStringData.get.success,
              ok: false,
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_INVERTER_STRING_DATA_RESET:
      return {
        ...state,
        inverterStringData: {
          ...state.inverterStringData.get,
          get: {
            ...INITIAL_STATE.inverterStringData.get,
            reset: true,
          },
        },
      };
    case actions.GET_PLANT_STATUS_LOADING:
      return {
        ...state,
        plantStatus: {
          ...state.plantStatus,
          get: {
            ...state.plantStatus.get,
            loading: true,
            reset: false,
            success: {
              ...state.plantStatus.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_PLANT_STATUS_SUCCESS:
      return {
        ...state,
        plantStatus: {
          ...state.plantStatus,
          get: {
            ...state.plantStatus.get,
            loading: false,
            reset: false,
            success: {
              ...state.plantStatus.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_PLANT_STATUS_FAILURE:
      return {
        ...state,
        plantStatus: {
          ...state.plantStatus,
          get: {
            ...state.plantStatus.get,
            loading: false,
            reset: false,
            success: {
              ...state.plantStatus.get.success,
              ok: false,
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_PLANT_STATUS_RESET:
      return {
        ...state,
        plantStatus: {
          ...state.plantStatus.get,
          get: {
            ...INITIAL_STATE.plantStatus.get,
            reset: true,
          },
        },
      };
    case actions.GET_DASHBOARD_STATS_LOADING:
      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats,
          post: {
            ...state.dashboardStats.post,
            loading: true,
            reset: false,
            success: {
              ...state.dashboardStats.post.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats,
          post: {
            ...state.dashboardStats.post,
            loading: false,
            reset: false,
            success: {
              ...state.dashboardStats.post.success,
              ok: true,
              data: {
                month_generation:
                  state.dashboardStats.post.success?.data?.month_generation,
                ...action.payload,
              },
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_DASHBOARD_STATS_FAILURE:
      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats,
          post: {
            ...state.dashboardStats.post,
            loading: false,
            reset: false,
            success: {
              ...state.dashboardStats.post.success,
              ok: false,
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_DASHBOARD_STATS_RESET:
      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats.get,
          post: {
            ...INITIAL_STATE.dashboardStats.post,
            reset: true,
          },
        },
      };
    case actions.GET_ALARM_EVENTS_LOADING:
      return {
        ...state,
        alarms: {
          ...state.alarms,
          get: {
            ...state.alarms.get,
            loading: true,
            reset: false,
            success: {
              ...state.alarms.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_ALARM_EVENTS_SUCCESS:
      return {
        ...state,
        alarms: {
          ...state.alarms,
          get: {
            ...state.alarms.get,
            loading: false,
            reset: false,
            success: {
              ...state.alarms.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_ALARM_EVENTS_FAILURE:
      return {
        ...state,
        alarms: {
          ...state.alarms,
          get: {
            ...state.alarms.get,
            loading: false,
            reset: false,
            success: {
              ...state.alarms.get.success,
              ok: false,
              data: [],
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_ALARM_EVENTS_RESET:
      return {
        ...state,
        alarms: {
          ...state.alarms.get,
          get: {
            ...INITIAL_STATE.alarms.get,
            reset: true,
          },
        },
      };
    case actions.GET_MONTH_GENERATION_LOADING:
      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats,
          post: {
            ...state.dashboardStats.post,
            loading: true,
            reset: false,
            success: {
              ...state.dashboardStats.post.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_MONTH_GENERATION_SUCCESS:
      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats,
          post: {
            ...state.dashboardStats.post,
            loading: false,
            reset: false,
            success: {
              ...state.dashboardStats.post.success,
              ok: true,
              data: {
                ...state.dashboardStats.post.success.data,
                month_generation: action.payload,
              },
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_MONTH_GENERATION_FAILURE:
      const obj = state.dashboardStats.post.success.data;
      delete obj.month_generation;

      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats,
          post: {
            ...state.dashboardStats.post,
            loading: false,
            reset: false,
            success: {
              ...state.dashboardStats.post.success,
              ok: false,
              data: {
                ...state.dashboardStats.post.success.data,
              },
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_MONTH_GENERATION_RESET:
      return {
        ...state,
        dashboardStats: {
          ...state.dashboardStats.post,
          post: {
            ...INITIAL_STATE.dashboardStats.post,
            reset: true,
          },
        },
      };
    case actions.GET_GENERATION_GRAPH_LOADING:
      return {
        ...state,
        generationGraphData: {
          ...state.generationGraphData,
          get: {
            ...state.generationGraphData.get,
            loading: true,
            reset: false,
            success: {
              ...state.generationGraphData.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_GENERATION_GRAPH_SUCCESS:
      return {
        ...state,
        generationGraphData: {
          ...state.generationGraphData,
          get: {
            ...state.generationGraphData.get,
            loading: false,
            reset: false,
            success: {
              ...state.generationGraphData.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_GENERATION_GRAPH_FAILURE:
      return {
        ...state,
        generationGraphData: {
          ...state.generationGraphData,
          get: {
            ...state.generationGraphData.get,
            loading: false,
            reset: false,
            success: {
              ...state.generationGraphData.get.success,
              ok: false,
              data: [],
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_GENERATION_GRAPH_RESET:
      return {
        ...state,
        generationGraphData: {
          ...state.generationGraphData.get,
          get: {
            ...INITIAL_STATE.generationGraphData.get,
            reset: true,
          },
        },
      };
    case actions.GET_INVERTER_GRAPH_DATA_LOADING:
      return {
        ...state,
        inverterGraphData: {
          ...state.inverterGraphData,
          get: {
            ...state.inverterGraphData.get,
            loading: true,
            reset: false,
            success: {
              ...state.inverterGraphData.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_INVERTER_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        inverterGraphData: {
          ...state.inverterGraphData,
          get: {
            ...state.inverterGraphData.get,
            loading: false,
            reset: false,
            success: {
              ...state.inverterGraphData.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_INVERTER_GRAPH_DATA_FAILURE:
      return {
        ...state,
        inverterGraphData: {
          ...state.inverterGraphData,
          get: {
            ...state.inverterGraphData.get,
            loading: false,
            reset: false,
            success: {
              ...state.inverterGraphData.get.success,
              ok: false,
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_INVERTER_GRAPH_DATA_RESET:
      return {
        ...state,
        inverterGraphData: {
          ...state.inverterGraphData.get,
          get: {
            ...INITIAL_STATE.inverterGraphData.get,
            reset: true,
          },
        },
      };
    case actions.GET_METRIC_TRENDS_LOADING:
      return {
        ...state,
        metricTrends: {
          ...state.metricTrends,
          post: {
            ...state.metricTrends.post,
            loading: true,
            reset: false,
            success: {
              ...state.metricTrends.post.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_METRIC_TRENDS_SUCCESS:
      return {
        ...state,
        metricTrends: {
          ...state.metricTrends,
          post: {
            ...state.metricTrends.post,
            loading: false,
            reset: false,
            success: {
              ...state.metricTrends.post.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case actions.GET_METRIC_TRENDS_FAILURE:
      return {
        ...state,
        metricTrends: {
          ...state.metricTrends,
          post: {
            ...state.metricTrends.post,
            loading: false,
            reset: false,
            success: {
              ...state.metricTrends.post.success,
              ok: false,
            },
            failure: {
              error: true,
              message: action.payload,
            },
          },
        },
      };
    case actions.GET_METRIC_TRENDS_RESET:
      return {
        ...state,
        metricTrends: {
          ...state.metricTrends.get,
          post: {
            ...INITIAL_STATE.metricTrends.post,
            reset: true,
          },
        },
      };
  }
  return state;
};

export default powerAMRReducers;
